/**
 * Constants ported from the legacy debitcardnodeweb summary
 * (`public/js/utils/constants.js` + `config/constants.json`), pared down to the
 * subset consumed by the CardDetails tree.
 */
import { EU_COUNTRIES as SHARED_EU_COUNTRIES } from '@/constants/common'

export const CARD_NUMBER_PREFIX = '••'

export const COUNTRY = {
  US: 'US',
  DE: 'DE',
  GB: 'GB',
  FR: 'FR',
  ES: 'ES',
  IT: 'IT',
  IE: 'IE',
  AT: 'AT',
  NL: 'NL',
  FI: 'FI',
  BE: 'BE',
  PT: 'PT',
} as const

// Re-export the shared EU country list so the ported tree stays self-contained.
export const EU_COUNTRIES = SHARED_EU_COUNTRIES

// Mirrors server/src/bdmc/shared/constants.ts — used for ATU vs BUFS tile modeling.
export const TOP_UP_COUNTRIES = ['GB', 'FR', 'IT', 'ES', 'IE', 'NL', 'FI', 'BE', 'PT'] as const
export const BACK_UP_FUNDING_COUNTRIES = ['DE', 'AT'] as const

export const SUPPORTED_CURRENCY_MAP: Record<string, string> = {
  US: 'USD',
  GB: 'GBP',
  DE: 'EUR',
  IE: 'EUR',
  FR: 'EUR',
  AT: 'EUR',
  IT: 'EUR',
  ES: 'EUR',
  BE: 'EUR',
  FI: 'EUR',
  PT: 'EUR',
  NL: 'EUR',
}

export const CARD_LIFE_CYCLE_STATES = {
  REISSUED: 'REISSUED',
  PENDING_ACTIVE: 'PENDING_ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
} as const

export const SHIPPING_STATUS = {
  NOT_SHIPPED: 'NOT_SHIPPED',
  ON_THE_WAY: 'ON_THE_WAY',
  ARRIVED: 'ARRIVED',
} as const

export const REWARDS_TIME = {
  SIX_MONTHS: '6',
} as const

export const PRODUCTS = {
  BUSINESS_DEBIT_CARD: 'BUSINESS_DEBIT_CARD',
  CONSUMER_DEBIT_CARD: 'CONSUMER_DEBIT_CARD',
  CONSUMER_VIRTUAL_DEBIT_CARD: 'CONSUMER_VIRTUAL_DEBIT_CARD',
} as const

export const PRODUCTS_THAT_RENDER_PILL: string[] = [PRODUCTS.CONSUMER_VIRTUAL_DEBIT_CARD]

// From config/constants.json
export const CARD_CAPABILITIES = {
  ACTIVATE: 'APPLICATIONS_ACTIVATE',
  SET_PIN: 'PINS_SET_PIN',
  SHOW_PIN: 'SHOW_PIN_SHOW_PIN',
  SHOW_CARD: 'SHOW_CARD_SHOW_CARD',
  REPORT_LOST: 'REPORT_CARD_LOST_REPORT_CARD_LOST',
  REPORT_DAMAGED: 'REISSUE_WORN',
  REPORT_DIGITAL_LOST: 'REPORT_CARD_LOST_REPORT_DIGITAL_CARD_LOST',
  DEACTIVATE: 'DEACTIVATE_DEACTIVATE',
  REACTIVATE: 'APPLICATIONS_REACTIVATE',
  CHANGE_BILIING_ADDRESS: 'UPDATE_CARD_DETAILS_CHANGE_BILLING_ADDRESS',
  REQUEST_PHYSICAL_CARD: 'REISSUE_CONVERT_FORM_FACTOR',
  CLOSE: 'CLOSE_CLOSE',
} as const

export const UCS_STUB_URL = '/myaccount/debitcards'

export const MAX_SECONDARY_CARDS_ALLOWED = 3

export const DEBIT_CARD_INCREMENT: Record<string, { cardFundingIncrement: number }> = {
  GB: { cardFundingIncrement: 5 },
  FI: { cardFundingIncrement: 5 },
  IE: { cardFundingIncrement: 5 },
  IT: { cardFundingIncrement: 5 },
  FR: { cardFundingIncrement: 5 },
  AT: { cardFundingIncrement: 5 },
  ES: { cardFundingIncrement: 5 },
  BE: { cardFundingIncrement: 5 },
  PT: { cardFundingIncrement: 5 },
  NL: { cardFundingIncrement: 5 },
}

export const BANK_ACCOUNT_TYPES = [
  'BUSINESS_CHECKING',
  'BUSINESS_SAVINGS',
  'CHECKING',
  'SAVINGS',
] as const

export const CARD_TYPES: Record<string, string> = {
  VISA: 'Visa',
  MASTER_CARD: 'Mastercard',
}

// i18n namespace prefix for the legacy `components/v2/strings.json` keys in ucsnodeweb.
export const STRINGS_PREFIX = 'components.v2.strings'
